export class RandomPicker {
	constructor(items) {
		if (!Array.isArray(items) || items.length === 0) {
			throw new Error("Items must be a non-empty array");
		}
		this.items = [...items]; // Copy original array
		this.remainingItems = [...items]; // Copy to track remaining
	}

	getRandomItem() {
		if (this.remainingItems.length === 0) {
			// Reset once all items have been drawn
			this.remainingItems = [...this.items];
		}

		// Get a random index from remaining items
		const randomIndex = Math.floor(Math.random() * this.remainingItems.length);
		const drawnItem = this.remainingItems.splice(randomIndex, 1)[0];

		return drawnItem;
	}
}
